export const META_ADS_PAGE_VIEW_HOST = "www.kopy.app"

export const META_ADS_EVENTS = {
	PAGE_VIEW: "PageView",
	VIEW_CONTENT: "ViewContent",
	COMPLETE_REGISTRATION: "CompleteRegistration",
	START_TRIAL: "StartTrial",
	PURCHASE: "Purchase",
}

export const shouldCaptureMetaAdsPageView = () => {
	if (typeof window === "undefined") return false

	return window.location.hostname === META_ADS_PAGE_VIEW_HOST
}

export const captureMetaAdsEvent = (
	posthog,
	event,
	properties = {},
	options = {},
) => {
	if (!posthog?.capture) return

	posthog.capture(
		event,
		{
			$current_url:
				typeof window !== "undefined" ? window.location.href : null,
			host:
				typeof window !== "undefined" ? window.location.hostname : null,
			path:
				typeof window !== "undefined" ? window.location.pathname : null,
			...properties,
		},
		options,
	)
}
